import styled, {css} from 'styled-components'

export const StyledDetailsTabContentWrapper = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 6}px;
    `
)
